module.exports = __webpack_public_path__ + "img/FK.a5e298cc.svg";